import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const Step4Position = ({ formData, handleChange, handleCheckboxArray }) => {
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const shifts = [
    { value: '1st', label: '1st Shift (7:00 AM – 3:00 PM)' },
    { value: '2nd', label: '2nd Shift (3:00 PM – 11:00 PM)' },
    { value: '3rd', label: '3rd Shift (11:00 PM – 7:00 AM)' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Position Type & Availability</h3>
        <p className="text-gray-600">Tell us about your availability</p>
      </div>

      <div>
        <Label>Position Type Applied For: *</Label>
        <div className="flex flex-wrap gap-4 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="position_type"
              value="full-time"
              checked={formData.position_type === 'full-time'}
              onChange={(e) => handleChange('position_type', e.target.value)}
              required
            />
            Full-Time
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="position_type"
              value="part-time"
              checked={formData.position_type === 'part-time'}
              onChange={(e) => handleChange('position_type', e.target.value)}
            />
            Part-Time
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="position_type"
              value="per-diem"
              checked={formData.position_type === 'per-diem'}
              onChange={(e) => handleChange('position_type', e.target.value)}
            />
            Per Diem
          </label>
        </div>
      </div>

      <div>
        <Label htmlFor="position_applied">Position Applied For *</Label>
        <Input
          id="position_applied"
          value={formData.position_applied}
          onChange={(e) => handleChange('position_applied', e.target.value)}
          required
          className="bg-gray-50"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="earliest_start_date">Earliest Available Start Date *</Label>
          <Input
            id="earliest_start_date"
            type="date"
            value={formData.earliest_start_date}
            onChange={(e) => handleChange('earliest_start_date', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="desired_pay_rate">Desired Pay Rate</Label>
          <Input
            id="desired_pay_rate"
            value={formData.desired_pay_rate}
            onChange={(e) => handleChange('desired_pay_rate', e.target.value)}
            placeholder="e.g., $15/hour"
          />
        </div>
      </div>

      <div>
        <Label>Days Available to Work: *</Label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2">
          {days.map((day) => (
            <label key={day} className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.days_available.includes(day)}
                onChange={(e) => handleCheckboxArray('days_available', day, e.target.checked)}
              />
              {day}
            </label>
          ))}
        </div>
      </div>

      <div>
        <Label>Preferred Shift(s): *</Label>
        <p className="text-sm text-gray-600 mb-2">
          *Shift preference is based on operational needs and availability and is not guaranteed*
        </p>
        <div className="space-y-2 mt-2">
          {shifts.map((shift) => (
            <label key={shift.value} className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.preferred_shifts.includes(shift.value)}
                onChange={(e) => handleCheckboxArray('preferred_shifts', shift.value, e.target.checked)}
              />
              {shift.label}
            </label>
          ))}
        </div>
      </div>

      <div className="bg-amber-50 p-4 rounded-lg">
        <Label>Weekend Requirement: *</Label>
        <p className="text-sm text-gray-700 mb-2">
          At least one (1) weekend shift per week is mandatory.
        </p>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.weekend_acknowledged === 'yes'}
            onChange={(e) => handleChange('weekend_acknowledged', e.target.checked ? 'yes' : '')}
            required
          />
          Acknowledged
        </label>
      </div>

      <div>
        <Label>Are you willing to work rotating shifts, if needed? *</Label>
        <div className="flex gap-4 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="willing_rotating_shifts"
              value="yes"
              checked={formData.willing_rotating_shifts === 'yes'}
              onChange={(e) => handleChange('willing_rotating_shifts', e.target.value)}
              required
            />
            Yes
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="willing_rotating_shifts"
              value="no"
              checked={formData.willing_rotating_shifts === 'no'}
              onChange={(e) => handleChange('willing_rotating_shifts', e.target.value)}
            />
            No
          </label>
        </div>
      </div>

      <div>
        <Label>Are you willing to work overtime or on-call shifts, as required? *</Label>
        <div className="flex gap-4 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="willing_overtime"
              value="yes"
              checked={formData.willing_overtime === 'yes'}
              onChange={(e) => handleChange('willing_overtime', e.target.value)}
              required
            />
            Yes
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="willing_overtime"
              value="no"
              checked={formData.willing_overtime === 'no'}
              onChange={(e) => handleChange('willing_overtime', e.target.value)}
            />
            No
          </label>
        </div>
      </div>

      <div>
        <Label htmlFor="scheduling_notes">Additional scheduling availability or limitations (optional):</Label>
        <Textarea
          id="scheduling_notes"
          value={formData.scheduling_notes}
          onChange={(e) => handleChange('scheduling_notes', e.target.value)}
          rows={3}
        />
      </div>
    </div>
  );
};

export default Step4Position;